import dayjs from "dayjs";

import type { TableMobileRowProps } from "../../../Table";
import type { AccountClientRow, AccountColumnLabels } from "../../types";

import { TableMobileHeader, TableMobileRow } from "../../../Table";

type Props = {
  language: string;
  translatedContent: AccountColumnLabels;
  columnVisibility: Record<string, boolean>;
  showOfferIdColumn?: boolean;
};

const COLUMN_DATE_FORMAT = "DD MMM YYYY";

export const MobileCardHeader =
  ({ translatedContent, columnVisibility }: Props) =>
  (row: AccountClientRow) => {
    const {
      accountID: accountId,
      executionType: accountType,
      clientID: clientId,
      name,
      email,
    } = row;

    const subHeaderRows: TableMobileRowProps[] = [
      {
        label: `${translatedContent?.acc} #`,
        value: accountId,
      },
      {
        label: translatedContent.accType,
        value: accountType,
      },
    ];
    const clientIdConfig = !Object.keys(columnVisibility).includes("clientId")
      ? {
          label: translatedContent.clientId,
          value: clientId,
        }
      : undefined;

    return (
      <TableMobileHeader
        name={name}
        email={email}
        clientId={clientIdConfig}
        subHeaderRows={subHeaderRows}
      />
    );
  };

export const MobileCardBody =
  ({ translatedContent, showOfferIdColumn = false }: Props) =>
  (row: AccountClientRow) => {
    const { firstTradedDate, lastTradedDate, hasOfferID, rebateAccountID } =
      row;

    return (
      <>
        <TableMobileRow
          label={translatedContent.firstTradedDate}
          value={
            firstTradedDate
              ? dayjs(firstTradedDate).format(COLUMN_DATE_FORMAT)
              : "-"
          }
        />
        <TableMobileRow
          label={translatedContent.lastTradedDate}
          value={
            lastTradedDate
              ? dayjs(lastTradedDate).format(COLUMN_DATE_FORMAT)
              : "-"
          }
        />
        {showOfferIdColumn && (
          <TableMobileRow
            label={translatedContent.hasOfferID}
            value={hasOfferID ? `HOID ${hasOfferID}` : "-"}
          />
        )}
        <TableMobileRow
          label={translatedContent.rebateAccount}
          value={rebateAccountID}
        />
      </>
    );
  };
